module.exports = __webpack_public_path__ + "static/media/prx.cb43ca58.png";